import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import QRCode from "react-qr-code";
import { useDispatch } from 'react-redux';
import { fetchCsrfCookie } from '../../../../redux/action/csrf/csrf-cookie';
import MainLoading from '../../../../utils/MainLoading';

const RecoveryCodes = () => {
    const {t} = useTranslation();
    const lang = localStorage.getItem('lang')
    const [loading, setLoading] = useState(false)
    const [showCodes, setShowCodes] = useState(true);
    const [qrCode, setQrCode] = useState('')
    const [recoveryCode, setRecoveryCode] = useState('')
    let dispatch = useDispatch()

    const handleClose = () => {
        setShowCodes(false)
        localStorage.setItem("two_factor", "true")
    };

    useEffect(()=> {
        setLoading(true)
        localStorage.setItem("two_factor", "true")
        dispatch(fetchCsrfCookie())
        axios.post('user/two-factor-authentication',{withCredentials: true})
        .then(res => {
            axios.get('user/two-factor-qr-code',{withCredentials: true})
            .then(res => {
                setLoading(false)
                setQrCode(res.data.url)
            })
            axios.get('user/two-factor-recovery-codes',{withCredentials: true})
            .then(res => {
                setLoading(false)
                setRecoveryCode(res.data)
            })
        })
    }, [])

    return (
        <Modal size='lg' show={showCodes} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title style={{fontSize: '1.1rem'}}>{t("Two-step verification enabled")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ?
                    <MainLoading />
                :
                    <>
                        <div className='qr_code'>
                            {lang === 'en' ?
                                <p className='my-3'>Scan the following QR code with authenticator apps like google authenticator to create a new one-time password for each login</p>
                            :
                                <p className='my-3'> کد QR زیر را توسط برنامه های authenticator مثل <strong>google authenticator</strong> اسکن کنید تا برای هر ورود شما رمز عبور یک بار مصرف جدیدی ایجاد شود</p>
                            }
                            <QRCode value={qrCode} className='qr_code_image' />
                        </div>
                            {lang === 'en' ?
                                <p className='my-3'>Store the following disposable codes in a safe place. These codes are displayed only once. If you do not have access to your authenticator account, you can use the following codes to log in.</p>
                            :
                                <><p className='mt-5'>کدهای یک بار مصرف زیر را در جای امنی ذخیره کنید. این کدها فقط یکبار نمایش داده می‌شوند</p><p> اگر به حساب برنامه‌ی authenticator خود دسترسی نداشته باشید، می‌توانید از کدهای زیر برای ورود استفاده کنید</p></>
                            }
                        <div className='mt-2 recovery-codes'>
                            {recoveryCode ? recoveryCode.map(item=> <input key={item} value={item} readOnly />) : ''}
                        </div>
                    </>
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleClose}>{t("I saved")}</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default RecoveryCodes
